/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as ConnectTrelloRouteImport } from './routes/connect-trello'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeamJoinRouteImport } from './routes/team/join'
import { Route as TeamDeleteRouteImport } from './routes/team/delete'
import { Route as OauthLoginRouteImport } from './routes/oauth/login'
import { Route as AccountDeleteRouteImport } from './routes/account/delete'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectTrelloRoute = ConnectTrelloRouteImport.update({
  id: '/connect-trello',
  path: '/connect-trello',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamJoinRoute = TeamJoinRouteImport.update({
  id: '/team/join',
  path: '/team/join',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamDeleteRoute = TeamDeleteRouteImport.update({
  id: '/team/delete',
  path: '/team/delete',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthLoginRoute = OauthLoginRouteImport.update({
  id: '/oauth/login',
  path: '/oauth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDeleteRoute = AccountDeleteRouteImport.update({
  id: '/account/delete',
  path: '/account/delete',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/connect-trello': typeof ConnectTrelloRoute
  '/verify-email': typeof VerifyEmailRoute
  '/account/delete': typeof AccountDeleteRoute
  '/oauth/login': typeof OauthLoginRoute
  '/team/delete': typeof TeamDeleteRoute
  '/team/join': typeof TeamJoinRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/connect-trello': typeof ConnectTrelloRoute
  '/verify-email': typeof VerifyEmailRoute
  '/account/delete': typeof AccountDeleteRoute
  '/oauth/login': typeof OauthLoginRoute
  '/team/delete': typeof TeamDeleteRoute
  '/team/join': typeof TeamJoinRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/connect-trello': typeof ConnectTrelloRoute
  '/verify-email': typeof VerifyEmailRoute
  '/account/delete': typeof AccountDeleteRoute
  '/oauth/login': typeof OauthLoginRoute
  '/team/delete': typeof TeamDeleteRoute
  '/team/join': typeof TeamJoinRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/connect-trello'
    | '/verify-email'
    | '/account/delete'
    | '/oauth/login'
    | '/team/delete'
    | '/team/join'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connect'
    | '/connect-trello'
    | '/verify-email'
    | '/account/delete'
    | '/oauth/login'
    | '/team/delete'
    | '/team/join'
  id:
    | '__root__'
    | '/'
    | '/connect'
    | '/connect-trello'
    | '/verify-email'
    | '/account/delete'
    | '/oauth/login'
    | '/team/delete'
    | '/team/join'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConnectRoute: typeof ConnectRoute
  ConnectTrelloRoute: typeof ConnectTrelloRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AccountDeleteRoute: typeof AccountDeleteRoute
  OauthLoginRoute: typeof OauthLoginRoute
  TeamDeleteRoute: typeof TeamDeleteRoute
  TeamJoinRoute: typeof TeamJoinRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect-trello': {
      id: '/connect-trello'
      path: '/connect-trello'
      fullPath: '/connect-trello'
      preLoaderRoute: typeof ConnectTrelloRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/join': {
      id: '/team/join'
      path: '/team/join'
      fullPath: '/team/join'
      preLoaderRoute: typeof TeamJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/delete': {
      id: '/team/delete'
      path: '/team/delete'
      fullPath: '/team/delete'
      preLoaderRoute: typeof TeamDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/login': {
      id: '/oauth/login'
      path: '/oauth/login'
      fullPath: '/oauth/login'
      preLoaderRoute: typeof OauthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/delete': {
      id: '/account/delete'
      path: '/account/delete'
      fullPath: '/account/delete'
      preLoaderRoute: typeof AccountDeleteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConnectRoute: ConnectRoute,
  ConnectTrelloRoute: ConnectTrelloRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AccountDeleteRoute: AccountDeleteRoute,
  OauthLoginRoute: OauthLoginRoute,
  TeamDeleteRoute: TeamDeleteRoute,
  TeamJoinRoute: TeamJoinRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
